import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data);
    } catch (e) {
      console.error("Failed to load site content", e);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <ContentContext.Provider value={{ content, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
